import React from 'react';
import BlogPost from "../BlogPost";

const OrthiAndOni = () => {
    return (
            <BlogPost
            id="OrthiAndTheOni"
            title="Orthi and the Oni"
            content={
                <>
                    I see it move, quick, darting through bushes. There, over a limb. Now, turning around
                    the tree. It tries to evade me but it can’t. I turn early, anticipating its next move
                    and force it to dodge. I’m the smarter of us through it and ends up gets caught in a
                    thick patch of young trees, each jostling the others in an attempt to reach up through
                    the thick canopy. The trees in the Hizarkian Valley grow thick after all. Reaching the
                    light is a great struggle. My prey cannot pass and as it turns to look for another
                    passage I leap into the air, drawing my staff and the shiny sword, a gift from my friend
                    Dolarn, and strike, a slash to the heel to stop it from fleeing. The beast collapses,
                    the cut leg unable to bear the weight. I land, pivot, and slam the quarterstaff into the
                    side of its head, striking true into the soft spot behind the ear. My prey wobbles for a
                    moment and then, with a loud thunk, falls over. I jump out of the way as it almost rolls
                    onto me. Looking at the giant boar I laugh heartily. &quot;Yes yes! Orthi Vepesk has
                    found a great dinner!&quot; I spend a little time tying the boar up and, finding
                    suitable bark to place under it, I begin to drag the beast back to the city of Khern.
                    It’ll be a long way I think to myself but I smile knowing how delicious the stew will be
                    after all the work. The dwarves of Khern are such good cooks after all! Though I’d
                    happily eat this as it is all the spices and cutting and ‘braising’, I think they call
                    it, does make it very very tasty.
                    <br/><br/>
                    The one watching Orthi ponders the sight they see. The light streaming through the
                    canopy leaves cause the green scales to glisten like emeralds but the blue streaks that
                    run between the scales is even stranger, not the usual patterning of a lizard folk. The
                    sight of one having hunted a giant boar alone not to mention dragging it alone uphill
                    through the forest too. Really quite the sight to see. The figure shifts from their
                    hiding spot and approaches Orthi. As they move their hulking form and blue skin begin to
                    change so that, when Orthi does see them at last, she only see’s an old human woman in
                    simple cloths walking towards her.
                    <br/><br/>
                    &quot;Hello! Who are you&quot; Orthi announces quizzically dropping the ropes and
                    walking over to the old lady.
                    <br/><br/>
                    &quot;Oh, me? I’m Neva. I’ve been on a pilgrimage you see and I think I’m a bit lost.
                    You seem very busy but I’m very tired and could use help finding the way back to the
                    main path.&quot;
                    <br/><br/>
                    Orthi looks them over and nods. &quot;Yes, you do look old and tired. Being lost is very
                    bad too&quot; she looks around for a moment and nods again before continuing &quot;the
                    path is that way.&quot; Orthi raises a pointed white claw but pauses and tilts her head
                    to the side and announces &quot;it is a bit far, and dangerous, and a bit steep of a
                    climb. I will take you!&quot; The old woman’s eyes widen as she takes in the strange
                    lizardfolk, or at least strange for a lizardfolk.
                    <br/><br/>
                    &quot;Oh my but what about your boar? Will you leave it behind?&quot;
                    <br/><br/>
                    Orthi laughs heartily. Leave food, she thinks to herself, what a silly old
                    lady. &quot;No no no. I just need a moment.&quot; Orthi picks a good looking tree and
                    climbs up, farther and farther, until her head pokes through the leaves. She raises
                    herself over the canopy and breaths the cool air. She feels it fill her lungs and she
                    holds it for a second before letting it go and whispering under her
                    breath &quot;come&quot;. The near cloudless sky cracks with
                    thunder. &quot;Come.&quot; Another crack, closer this time.&quot; Orthi feels it now.
                    The static in the air growing. The slight shift in the breeze. If the old woman could
                    see her she’d see the normally brown eyes of Orthi, just another lizardfolk to a lay
                    person, turn blue and sparkle. &quot;Come!&quot; Another crack and, along with it,
                    lightning strikes the tree top and Orthi.
                    <br/><br/>
                    &quot;Oh my&quot; the old woman shrieks as the treetops burst with light and the feeling
                    of the lightnings impact slams into her, the pressure of the sound enough to knock this
                    form over. &quot;What&quot; she begins to say as the lizardfolk scurries down the trunk
                    as if nothing happened. Before the old woman can say another word she feels the
                    lizardfolk lift her into their arms and watches them grab the rope in their teach and
                    lowering themselves to the ground begin running on all fours, three really given the one
                    arm being used to carry the woman. As she hangs there in the air the old woman takes in
                    the lizardfolk again seeing now those slight patterning in their scales has become a
                    vibrant blue, glowing, almost as if charged and their eyes, now a beautiful sapphire
                    like a fresh water lake.
                    <br/><br/>
                    Only the sound of the boar dragging behind them fills the air until they finally reach
                    the main road. Orthi places the old woman down and stands stretching for a moment before
                    pointing and saying &quot;this way to Khern and that way to the road to Hizark Kingdom
                    or Reyland. Be safe now, no more getting lost.&quot; Orthi grins a toothy grin, her
                    pointed teeth quite a sight.   &quot;Hehehehe&quot; the old woman laughs stepping
                    backward and raising a hand to cover her face as her limbs begin to elongate and voice
                    deepen. &quot;You are one of the more interesting fellows I’ve found in these woods over
                    the years.&quot; The skin of the creature darkens to its unnatural blue tone, its eyes
                    yellowing, and horns rising from its forehead. &quot;What is your name lizard of
                    lightning? What may I grant you for your kindness.&quot;  Orthi looks the creature over
                    and announces &quot;Oh you’re that Oni thing! I think a friend met you once! You’re very
                    blue just like the blue in my scales&quot; the joy in her voice leaving the Oni staring
                    back in confusion. &quot;Oh, uh, I didn’t answer your questions. I’m Orthi and, um, I’m
                    good but here&quot; she turns and slices a chunk out of the giant boar &quot;take this!
                    Food tastes best when shared after all.&quot; Before the Oni can overcome their
                    bafflement Orthi has already grabbed the rope and begun to run up the path, filled with
                    excitement for how much better the food will be knowing she shared it with another
                    ‘person’. The Oni watches as Orthi bolts up and out of sight the blue light trailing
                    after her just a bit. With a snicker the Oni raises their hood overhead and turns to
                    begin walking the path in the opposite direction. With a wave of their hand they begin
                    to vanish whispering as they go &quot;till we meet again Orthi, Lizard of
                    Lightning.&quot;
                </>
            }
            photoSrc=""
            photoAlt=""
            noteText="Haven't seen him again. He was nice. Hope I see him again soon. Wish he could have had that boar stew. Maybe next time! - Orthi Vepesk"
        />
    );
};

export default OrthiAndOni;
